import React, { Component } from 'react'
import Header from './Navigation/Header'
import Footer from './Navigation/Footer'
import Fonctionnement from './Components/Fonctionnement'
import Faq from './Components/Faq'
import Slider from './Components/Slider'
import Notice from './Components/Notice'
import Notice1 from './Components/Notice1'
import Notice2 from './Components/Notice2'
import Section1 from './Components/Section1'
import Section2 from './Components/Section2'
import { Seo } from '../helpers/Seo'

class Home extends Component {
    render() {
        return (
            <div>
                <Seo
                    title="Personal Loan $100 Approved Without Documents in Quebec | GoodGoodFinance"
                    description="Easily compare personal loans approved without documents on GoodGoodFinance. Find the ideal option for your financial needs."
                    type="webapp"
                    name="GoodGoodFinance"
                />
                <Header />
                <Slider />
                <main id="main">
                    <Fonctionnement />
                    <Faq />
                    <Notice />
                    <Section1 />
                    <Notice1 />
                    <Section2 />
                    <Notice2 />
                </main>
                <Footer />
            </div>
        )
    }
}
export default Home
